var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainCopy"},[_c('div',{staticClass:"mainCopyText",domProps:{"innerHTML":_vm._s(_vm.mainCopy)}}),_c('div',{staticClass:"kingaku",domProps:{"textContent":_vm._s(_vm.shusiText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }